module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-8k-7a2ed972.svg";